export default __webpack_public_path__ + "static/media/euro-bg-desktop.3f49a6ab.jpg";